module.exports = __webpack_public_path__ + "static/media/logo_iter.0d7277dd.jpg";